export default __webpack_public_path__ + "static/media/banner-nova-regra-iof.1cfcdba8.png";